import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { ModalService } from '@philips-internal/oswald-ui-components';
import { ModalButtonType, ThemeTonalRange } from '@philips-internal/oswald-ui-constants';
import { SessionStorageService } from '@philips-internal/oswald-ui-core/lib/services/index.js';
import { isContentfulString } from '@philips-internal/oswald-ui-utils';
import { BROWSING_CONTEXT_ID_KEY, BrowsingContextMessageType, BrowsingContextService } from '../services/browsing-context/browsing-context-service.js';
const READY_MESSAGE = {
    data: undefined,
    type: BrowsingContextMessageType.READY,
};
const CLOSING_MESSAGE = {
    data: undefined,
    type: BrowsingContextMessageType.CLOSING,
};
const REFUSED_CLOSE_MESSAGE = {
    data: undefined,
    type: BrowsingContextMessageType.CLOSE_REFUSED,
};
/**
 * Custom hook for mananging browsing context channels status.
 */
function useBrowsingContext() {
    const [contextId, setContextId] = useState('');
    const [searchParams] = useSearchParams();
    useEffect(() => {
        if (!searchParams.get(BROWSING_CONTEXT_ID_KEY) || isContentfulString(contextId)) {
            return;
        }
        if (isContentfulString(searchParams.get(BROWSING_CONTEXT_ID_KEY))) {
            const contextId = String(searchParams.get(BROWSING_CONTEXT_ID_KEY));
            SessionStorageService.setItem(BROWSING_CONTEXT_ID_KEY, contextId);
            setContextId(contextId);
        }
    }, [searchParams.get(BROWSING_CONTEXT_ID_KEY)]);
    useEffect(() => {
        if (!isContentfulString(contextId)) {
            return;
        }
        BrowsingContextService.sendMessage(contextId, READY_MESSAGE);
        const handleCloseRequest = (data) => {
            const onConfirmClose = () => {
                handleWindowClosing();
                window.close();
            };
            if (!data.askForConfirmation) {
                return onConfirmClose();
            }
            const onCancelClose = () => {
                BrowsingContextService.sendMessage(contextId, REFUSED_CLOSE_MESSAGE);
            };
            const dockButtons = [
                {
                    action: onConfirmClose,
                    title: 'oswald.browsing-context.close-dialog.confirm',
                    type: ModalButtonType.SUCCESS,
                },
                {
                    action: onCancelClose,
                    title: 'oswald.browsing-context.close-dialog.cancel',
                    type: ModalButtonType.CANCEL,
                },
            ];
            ModalService.openDialog({
                closeable: false,
                dialogDescription: data.dialogDescription ?? 'oswald.browsing-context.close-dialog.description',
                dockButtons,
                theme: ThemeTonalRange.ULTRA_LIGHT,
                title: 'oswald.browsing-context.close-dialog.title',
            });
        };
        const handleWindowClosing = () => {
            BrowsingContextService.sendMessage(contextId, CLOSING_MESSAGE);
        };
        const abortController = new AbortController();
        const unlistenCloseRequest = BrowsingContextService.listenMessage(contextId, BrowsingContextMessageType.CLOSE_REQUEST, handleCloseRequest);
        window.addEventListener('unload', handleWindowClosing, { signal: abortController.signal });
        return () => {
            unlistenCloseRequest();
            abortController.abort();
        };
    }, [contextId]);
}
export { useBrowsingContext, };
//# sourceMappingURL=use-browsing-context.js.map